import(/* webpackMode: "eager" */ "/home/hpbs/frontend/app/global-error.tsx");
